import type { Locale } from "@tami/core/intl";

import { localizedPath } from "@/lib/i18n/locale-path";

import { LEGAL_COPY } from "./legal.copy";

export type LegalDocumentSlug = "termos-de-uso" | "politica-de-privacidade";

export type LegalDocument = {
  readonly slug: LegalDocumentSlug;
  readonly title: string;
  readonly description: string;
  /**
   * Nome do arquivo dentro de `src/content/legal` (o português) e de
   * `src/content/legal/en-us` e `es-es` (as traduções).
   */
  readonly fileName: string;
  /** Data ISO `YYYY-MM-DD`. Renderizada como "Última atualização em ...". */
  readonly updatedAt: string;
};

export const TERMS_OF_USE_DOCUMENT: LegalDocument = {
  slug: "termos-de-uso",
  // Getters: o idioma pode trocar em tempo de execução, e valor lido no import
  // congelaria o texto.
  get title() {
    return LEGAL_COPY.terms.title;
  },
  get description() {
    return LEGAL_COPY.terms.description;
  },
  fileName: "termos-de-uso.md",
  updatedAt: "2026-10-14",
};

export const PRIVACY_POLICY_DOCUMENT: LegalDocument = {
  slug: "politica-de-privacidade",
  get title() {
    return LEGAL_COPY.privacy.title;
  },
  get description() {
    return LEGAL_COPY.privacy.description;
  },
  fileName: "politica-de-privacidade.md",
  updatedAt: "2026-10-14",
};

export const LEGAL_DOCUMENTS: readonly LegalDocument[] = [
  TERMS_OF_USE_DOCUMENT,
  PRIVACY_POLICY_DOCUMENT,
];

/**
 * Endereço da página no idioma pedido: `/termos-de-uso` em português (o de
 * sempre), `/en/termos-de-uso` e `/es/termos-de-uso` nas traduções.
 */
export function legalDocumentPath(legalDocument: LegalDocument, locale: Locale): string {
  return localizedPath(`/${legalDocument.slug}`, locale);
}
